/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function () {
        // JavaScript to be fired on all pages
      },
      finalize: function () {


        (function () {
          $(window).load(function () {
            $(".spinner").delay(100).fadeOut(200);
            $("#preloader").delay(300).fadeOut(200);
          });

          $('a[target="_blank"]').each(function(){
            $(this).removeAttr('target');
         });


          $(document).ready(function () {

            $('.picturebox a[target="_blank"]').removeAttr('target');
            $('.menu a[target="_blank"]').removeAttr('target');

            var urlHashtag = document.location.toString();
            if (urlHashtag.match('#')) {
              $('.nav-tabs a[href=#' + urlHashtag.split('#')[1] + ']').tab('show');
            }

            // Change hash for page-reload
            $('.nav-tabs a').on('shown', function (e) {
              window.location.hash = e.target.hash;
            });

            // function isEmpty vérifie si un élement est vide
            function isEmpty(el) {
              return !$.trim(el.html());
            }

            /*
             * CAROUSEL
             */

            // Carousel HOMEPAGE
            $('div.carousel-inner', 'div#carousel-accueil').find("div.item:first-child").addClass("active");
            var url = $('div.item.active', 'div#carousel-accueil').attr("data-target");
            $('#plus-de-details').attr("href", url);

            var carouselImageDetached = $('.item.active', 'div#carousel-accueil').find('img').detach();
            $('.item.active', 'div#carousel-accueil').append('<a href="' + url + '">');
            $('.item.active a', 'div#carousel-accueil').append(carouselImageDetached);

            var nbItems;
            nbItems = $('.item', 'div#carousel-accueil').length;
            if (nbItems === 0) {
              //    $('#plus-de-details').hide();
            }
            else if (nbItems > 1) {
              for ($i = 0; $i < nbItems; $i++) {
                if ($i === 0) {
                  $('div#carousel-accueil').find(".carousel-indicators").append("<li data-target='#carousel-accueil' data-slide-to=" + $i + " class='active'></li>");
                }
                else {
                  $('div#carousel-accueil').find(".carousel-indicators").append("<li data-target='#carousel-accueil' data-slide-to=" + $i + "></li>");
                }
              }
            }
            // Extraction du lien de l'image du carousel pour l'attribuer au bouton adjacent
            $('div#carousel-accueil').on('slid.bs.carousel', function () {
              var url = $('div.item.active', 'div#carousel-accueil').attr("data-target");
              $('#plus-de-details').attr("href", url);
              var carouselImageDetached = $('.item.active', 'div#carousel-accueil').find('img').detach();
              $('.item.active', 'div#carousel-accueil').empty().append('<a href="' + url + '">');
              $('.item.active a', 'div#carousel-accueil').append(carouselImageDetached);
            });
            // Suppression du bouton si le carousel est vide
            if (!isEmpty($($("#carousel-accueil .carousel-inner")))) {
              $('#plus-de-details').css("display", "block");
            }
            // Démarrage du carousel
            $('div#carousel-accueil').carousel({interval: 7000});

            // Carousel PAGE ETUDES
            $('div#carousel-etude-collegial, div#carousel-etude-secondaire-filles, div#carousel-etude-secondaire-garcons').carousel({
              interval: 10000,
              pause: "false"
            });

            /*
             * MENU
             */
            // Désactivation des clicks sur les menus dropdown sans page
            var menuEtudes = "menu-etudes";
            var menuProgrammes = "menu-programmes";
            var menuProfils = "menu-profils";
            var menuSports = "menu-sports";

            $('nav.nav-main .menu-item-has-children > a').click(function (e) {
              e.preventDefault();
              e.stopPropagation();
              console.log('click');
              if (!($(this).parent().hasClass(menuEtudes) || $(this).parent().hasClass(menuProgrammes) || $(this).parent().hasClass(menuProfils) || $(this).parent().hasClass(menuSports))) {
                location.href = this.href;
              }
            });


            // Rajout de target _blank pour le lien Atrium
            $("li.menu-atrium a").attr("target", "_blank");

            // Suppression des élements non visible sur mobile
            $("ul#menu-primary-navigation", ".menu-navigation-mobile").find(".menu-programmes").remove();
            $("ul#menu-primary-navigation", ".menu-navigation-mobile").find(".menu-profils").remove();

            /*
             * NAV TABS
             */
            // Page ADMISSION
            var classAdmission = "secondaire-filles secondaire-garcons collegial default";
            var liensUtilesCollegial = $("#menu-liens-utiles-admission-collegial-1, #menu-liens-utiles-admission-collegial-2");
            var liensUtilesSecondaireFilles = $("#menu-liens-utiles-admission-secondaire-filles-1, #menu-liens-utiles-admission-secondaire-filles-2");
            var liensUtilesSecondaireGarcons = $("#menu-liens-utiles-admission-secondaire-garcons-1, #menu-liens-utiles-admission-secondaire-garcons-2");
            $('.nav-tabs .collegial').click(function (e) {
              e.preventDefault();
              $(this).tab('show');
              $("div.inscription").removeClass(classAdmission).addClass("collegial");
              $(this).parents("ul").removeClass(classAdmission + " default").addClass("collegial");
              liensUtilesCollegial.show();
              liensUtilesSecondaireFilles.hide();
              liensUtilesSecondaireGarcons.hide();
            });
            $('.nav-tabs .secondaire-filles').click(function (e) {
              e.preventDefault();
              $(this).tab('show');
              $("div.inscription").removeClass(classAdmission).addClass("secondaire-filles");
              $(this).parents("ul").removeClass(classAdmission + " default").addClass("secondaire-filles");
              liensUtilesCollegial.hide();
              liensUtilesSecondaireFilles.show();
              liensUtilesSecondaireGarcons.hide();
            });
            $('.nav-tabs .secondaire-garcons').click(function (e) {
              e.preventDefault();
              $(this).tab('show');
              $("div.inscription").removeClass(classAdmission).addClass("secondaire-garcons");
              $(this).parents("ul").removeClass(classAdmission + " default").addClass("secondaire-garcons");
              liensUtilesCollegial.hide();
              liensUtilesSecondaireFilles.hide();
              liensUtilesSecondaireGarcons.show();
            });

            // Page BIBLIOTHEQUE
            var classBibliotheque = "default bibliotheque-du-collegial bibliotheque-du-secondaire bibliotheque-de-la-compagnie-de-jesus";
            var classHeader = "bibliotheque-collegial bibliotheque-secondaire bibliotheque-compagnie-jesus";
            $(".lien-bibliotheque-collegial").addClass("active");

            $('.nav-tabs .bibliotheque-du-collegial').click(function (e) {
              e.preventDefault();
              $(this).tab('show');
              $(this).parents("ul").removeClass(classBibliotheque).addClass("bibliotheque-du-collegial");
              $(".bibliotheque-header .bibliotheque-collegial").css('opacity', 1);
              $(".bibliotheque-header .bibliotheque-secondaire").css('opacity', 0);
              $(".bibliotheque-header .bibliotheque-compagnie-jesus").css('opacity', 0);
              $(".lien-bibliotheque-secondaire").removeClass("active");
              $(".lien-bibliotheque-jesus").removeClass("active");
              $(".lien-bibliotheque-collegial").addClass("active");
            });
            $('.nav-tabs .bibliotheque-du-secondaire').click(function (e) {
              e.preventDefault();
              $(this).tab('show');
              $(this).parents("ul").removeClass(classBibliotheque).addClass("bibliotheque-du-secondaire");
              $(".bibliotheque-header .bibliotheque-secondaire").css('opacity', 1);
              $(".bibliotheque-header .bibliotheque-collegial").css('opacity', 0);
              $(".bibliotheque-header .bibliotheque-compagnie-jesus").css('opacity', 0);
              $(".lien-bibliotheque-collegial").removeClass("active");
              $(".lien-bibliotheque-jesus").removeClass("active");
              $(".lien-bibliotheque-secondaire").addClass("active");
            });
            $('.nav-tabs .bibliotheque-de-la-compagnie-de-jesus').click(function (e) {
              e.preventDefault();
              $(this).tab('show');
              $(this).parents("ul").removeClass(classBibliotheque).addClass("bibliotheque-de-la-compagnie-de-jesus");
              $(".bibliotheque-header .bibliotheque-compagnie-jesus").css('opacity', 1);
              $(".bibliotheque-header .bibliotheque-secondaire").css('opacity', 0);
              $(".bibliotheque-header .bibliotheque-collegial").css('opacity', 0);
              $(".lien-bibliotheque-secondaire").removeClass("active");
              $(".lien-bibliotheque-collegial").removeClass("active");
              $(".lien-bibliotheque-jesus").addClass("active");
            });

            /*
             * ACCORDEON
             */
            //  $('.panel-heading a').on('show.bs.collapse', function () {
            //    if($(this).parents('.panel').children('.panel-collapse').hasClass('in')){
            //      e.stopPropagation();
            //    }
            //  });

            //  $('#collapseOne').on('hidden.bs.collapse', function () {
            //    $(".glyphicon.glyphicon-chevron-right").removeClass("glyphicon-chevron-right").addClass("glyphicon-chevron-down");
            //  });
            // $('.panel-heading a').on('click', function (e) {
            //   if ($(this).parents('.panel').children('.panel-collapse').hasClass('in')) {
            //     e.stopPropagation();
            //   }
            // });

            /*
             * ALERT HOMEPAGE
             */

            // Vérification du remplissage de l'alerte pour son affichage
            if (!isEmpty($($(".modal-body")))) {
              $('#ModalAlert').modal();
            }

            /*
             * TABLE OF CONTENTS
             */
            // Intégration du sommaire dans la colonne de gauche
            var tableOfContents = $("div#toc_container").detach();
            $("div.table-of-contents").append(tableOfContents);

            /*
             * ALERTE HOMEPAGE
             */
            //changement aléatoire des images de la page d'accueil
            function getRandom(min, max) {
              return Math.floor(Math.random() * (max - min)) + min;
            }

            var home = $("div.home");
            $("div.collegial", home).find(".overlay").addClass("overlay" + getRandom(1, 4));
            $("div.secondaire-filles", home).find(".overlay").addClass("overlay" + getRandom(1, 4));
            $("div.secondaire-garcons", home).find(".overlay").addClass("overlay" + getRandom(1, 4));

            /*
             * SEARCH
             */
            // Intégration du nombre de résultats de recherche dans la colonne de gauche
            var nbResultats = $("p.nb-resultats").detach();
            $("div#nb-resultats").append(nbResultats);

            /*
             * RSS
             */
            //Rajout du bouton lire davantage
            var lienActuSecFilles = $(".actualite-secondaire-filles").find("a.rsswidget:last-child").attr("href");
            var lienActuSecGarcons = $(".actualite-secondaire-garcons").find("a.rsswidget:last-child").attr("href");
            var lienActuCollegial = $(".actualite-collegial").find("a.rsswidget:last-child").attr("href");
            $(".actualite-secondaire-filles div.rss-wrapper").append("<a class='more' href='" + lienActuSecFilles + "'>Lire davantage</a>");
            $(".actualite-secondaire-garcons div.rss-wrapper").append("<a class='more' href='" + lienActuSecGarcons + "'>Lire davantage</a>");
            $(".actualite-collegial div.rss-wrapper").append("<a class='more' href='" + lienActuCollegial + "'>Lire davantage</a>");

            $(".actualite a").attr("target", "_blank");

            /*
             * MAILCHIMP SIGNUP FORM
             */
            // Rajout des placeholder correspondant
            $("#mc_mv_EMAIL").attr("placeholder", "Courriel");
            $("#mc_mv_FNAME").attr("placeholder", "Nom et prénom");
            $("#mc_mv_MMERGE3").prepend("<option value='' selected disabled>Intérêt</option>");
            //var $subheader = $("div#mc_subheader").detach();
            //$("div#mc_signup").append($subheader);

          });
        })();


      }
    },
    // Home page
    'home': {
      init: function () {
        // JavaScript to be fired on the home page
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function () {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
